import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=f8e909b6&scoped=true&"
import script from "./ViewForm.vue?vue&type=script&lang=ts&"
export * from "./ViewForm.vue?vue&type=script&lang=ts&"
import style0 from "./ViewForm.vue?vue&type=style&index=0&id=f8e909b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e909b6",
  null
  
)

export default component.exports